import type { App as VueApp, Plugin } from "vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import Pagination from "@Scripts/Components/Pagination/Pagination.vue";

import CloseDialog from "@Scripts/Directives/CloseDialog/CloseDialog";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("app-cookietoast", CookieToast);
        app.component("app-inforequest", InfoRequest);
        app.component("app-pagination", Pagination);

        app.directive("close-dialog", CloseDialog);
    }
};

export default AppConfig;